<template>
  <div class="cart-page page">
    <CartHeader :breadcrumbs="breadcrumbs" />
    <div v-if="loading" class="page-loading">{{ $t("services.loading") }}</div>
    <div class="page-loading" v-else-if="is403Error">
      {{ $t("event.error403") }}
    </div>
    <div
      v-else-if="cartServicesList?.length && !loading"
      class="cart-page__inner container"
    >
      <ServiceListTableComponent
        :rows="cartServicesList"
        action="delete"
        is-cart
      />
      <div class="cart-page__bottom">
        <div>
          <div class="cart-page__info">
            <span class="cart-page__info-title">
              {{ $t("services.servicesSumWithVat") }}:
            </span>
            <span class="cart-page__info-value">
              {{ cartSum() | formatPrice({ store: $store }) }}
            </span>
          </div>
          <div class="cart-page__info">
            <span class="cart-page__info-title">
              {{ $t("services.standTitle") }}:
            </span>
            <span class="cart-page__info-subvalue">
              {{ currentStand?.title || "-" }}
            </span>
          </div>
        </div>
        <PrimaryButton
          @click="$router.push({ name: 'order' })"
          class="cart-page__order-btn primary-button"
          :disabled="!isOrderingAvailable"
        >
          {{ $t("services.cart.createOrder") }}
        </PrimaryButton>
      </div>
    </div>
    <CartEmpty v-else />
  </div>
</template>

<script>
import CartHeader from "@/components/Custom/CartHeader.vue";
import ServiceListTableComponent from "@/components/UI/Table/ServiceListTableComponent.vue";
import CartEmpty from "@/components/Custom/CartEmpty.vue";
import { mapGetters, mapState } from "vuex";
import diffInSeconds from "@/helpers/diffInSeconds";
import { PrimaryButton } from "@v2/shared/ui/components";

export default {
  name: "CartPage",
  components: {
    PrimaryButton,
    CartEmpty,
    ServiceListTableComponent,
    CartHeader
  },
  data() {
    return {
      breadcrumbs: [
        {
          title_rus: "Выставка",
          title_eng: "Exhibition",
          route: { name: "participant", params: { id: this.$route.params.id } }
        },
        {
          title_rus: "Заказ услуг",
          title_eng: "Services order",
          route: { name: "categories", params: { id: this.$route.params.id } }
        }
      ],
      loading: false,
      is403Error: false
    };
  },
  created() {
    this.load();
  },
  computed: {
    ...mapState("event", ["event", "currentStand"]),
    ...mapState("services", ["cart"]),
    ...mapGetters("services", ["cartServicesList", "cartSum", "currency"]),

    isOrderingAvailable() {
      return this.event.exhibition.is_allowed_create_additional_order;
    }
  },
  methods: {
    diffInSeconds,
    async load() {
      try {
        this.loading = true;
        await this.$store.dispatch("services/getCart", this.$route.params.id);
      } catch (e) {
        this.is403Error = e.error_data?.response?.status === 403;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.cart-page {
  min-height: 100%;
  flex-grow: 1;
  background-color: var(--gray, #f9f9f9);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .container {
    width: 100%;
    @media (max-width: 740px) {
      width: auto;
      margin-left: 30px;
      margin-right: 30px;
    }
  }

  &__inner {
    padding: 50px 0;
    flex-grow: 1;
    @media (max-width: 540px) {
      padding: 30px 0;
    }
  }

  &__bottom {
    margin-top: 30px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    @media (max-width: 540px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__info {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    @media (max-width: 540px) {
      margin-bottom: 15px;
    }

    &-title {
      color: var(--dark-light, #6d7179);
      font-feature-settings: "clig" off, "liga" off;
      font-size: 1rem;
      font-weight: 500;
      line-height: 24px;
      margin-right: 10px;
    }

    &-value {
      color: var(--dark, #262626);
      font-feature-settings: "clig" off, "liga" off;
      font-size: 1.375rem;
      font-weight: 700;
      line-height: 28px;
    }

    &-subvalue {
      color: var(--dark, #262626);
      font-feature-settings: "clig" off, "liga" off;
      font-size: 1.1rem;
      font-weight: 700;
      line-height: 25px;
    }
  }

  &__order-btn {
    @media (max-width: 420px) {
      width: 100%;
    }
  }
}
</style>
